'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecommendedVenuesContainer = undefined;

var _reactRedux = require('react-redux');

var _bound = require('redux/saga/entities/bound');

var _RecommendedVenues = require('./RecommendedVenues');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var recommendations = _bound.similarVenues.data(state, ownProps.venueId) || [];
  var similar = recommendations.slice(0, 2);

  return {
    recommendations: similar.map(function (recommendation) {
      return {
        alias: recommendation.alias,
        imageUrl: recommendation.images.default,
        venue: recommendation.name
      };
    }),
    venue: ownProps.venue,
    venueId: ownProps.venueId
  };
};

var RecommendedVenuesContainer = exports.RecommendedVenuesContainer = (0, _reactRedux.connect)(mapStateToProps)(_RecommendedVenues.RecommendedVenues);